/** Locally bundled, licensed sources. See /audio/manifest.json for provenance. */
export const MUSIC = [
  {
    title: 'Origami',
    url: '/audio/music/origami.mp3',
    seconds: 189.23,
    gain: 0.72,
    source: 'https://www.scottbuckley.com.au/library/origami/',
  },
  {
    title: 'Reverie',
    url: '/audio/music/reverie.mp3',
    seconds: 223.67292517006803,
    gain: 0.72,
    source: 'https://www.scottbuckley.com.au/library/reverie/',
  },
  {
    title: 'Amberlight',
    url: '/audio/music/amberlight.mp3',
    seconds: 282.90598639455783,
    gain: 0.72,
    source: 'https://www.scottbuckley.com.au/library/amberlight/',
  },
  {
    title: 'Echoes Of Home',
    url: '/audio/music/echoes-of-home.mp3',
    seconds: 291.71845804988664,
    gain: 0.72,
    source: 'https://www.scottbuckley.com.au/library/echoes-of-home/',
  },
  {
    title: 'A Kind Of Hope',
    url: '/audio/music/a-kind-of-hope.mp3',
    seconds: 342.60054421768706,
    gain: 0.72,
    source: 'https://www.scottbuckley.com.au/library/a-kind-of-hope/',
  },
  {
    title: 'Moonlight',
    url: '/audio/music/moonlight.mp3',
    seconds: 254.33374149659863,
    gain: 0.72,
    source: 'https://www.scottbuckley.com.au/library/moonlight/',
  },
  {
    title: 'Aurora',
    url: '/audio/music/aurora.mp3',
    seconds: 498.7674829931973,
    gain: 0.72,
    source: 'https://www.scottbuckley.com.au/library/aurora/',
  },
  {
    title: 'Home Was You',
    url: '/audio/music/home-was-you.mp3',
    seconds: 269.4,
    gain: 0.72,
    source: 'https://www.scottbuckley.com.au/library/home-was-you/',
  },
] as const;
